import { ProgressBar } from 'react-bootstrap';

export const CompactViewProgressBarComponent = ({
  min,
  max,
  value,
}: {
  min: number;
  max: number;
  value: number;
}) => {
  return (
    <ProgressBar
      max={max}
      min={min}
      now={value}
      className="compactviewpragressbar"
    />
  );
};
